<div class="dashboard-container">
    <app-header-trade></app-header-trade>

  <app-ticker-tape></app-ticker-tape>
  <div class="container">
    <div class="content-grid">
      <div class="left-column">
    <app-exchange-price></app-exchange-price>
   <app-chart
          *ngIf="chartStatus"
          class="trade_chart baseblock_wrapper"
          [chartData]="chartData" 
        ></app-chart> 
        <app-arbitrage-profit></app-arbitrage-profit>  
    <!-- <app-exchange-trading-interface></app-exchange-trading-interface> -->
      </div>
      <div class="right-column">
    <app-top-exchanges></app-top-exchanges>
      </div>
    </div>
  </div>
</div>